import { createApi } from '@reduxjs/toolkit/query/react'
import {fetchBaseQuery} from "@reduxjs/toolkit/query";

const refetchSeconds = process.env.REACT_APP_REFETCH_SECONDS ? parseInt(process.env.REACT_APP_REFETCH_SECONDS) : 30;

export const sharedListedAnimeApi = createApi({
    reducerPath: 'sharedListedAnimeApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BASE_API_URL}/api/v2`,
        prepareHeaders: (headers) => {
            const code = process.env.REACT_APP_AZURE_KEY;

            if (!code) {
                console.error("No code in env file!");
                return;
            }

            headers.set('x-functions-key', code);

            return headers
        }
    }),
    tagTypes: ["ListedAnime"],
    keepUnusedDataFor: 300,
    refetchOnMountOrArgChange: refetchSeconds,
    endpoints: (builder) => ({
        getSharedListedAnimeOfList: builder.query({
            query: ({
                slug,
                status,
                username
            }) => {
                let url = `${username}/shared/anime-lists/${slug}/listed-anime-items/${status}`

                return {url}
            },
            providesTags:["ListedAnime"]
        }),
    }),
})

export const {
    useLazyGetSharedListedAnimeOfListQuery
} = sharedListedAnimeApi
